module.exports = __webpack_public_path__ + "img/1447406946.774491a0.jpg";